import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {HttpClient} from '@angular/common/http';
import {of} from 'rxjs/internal/observable/of';
import {Subscription} from 'rxjs';
import {ConsuntivoUploadService} from '../../monthly-actual/consuntivo-upload/service-consuntivo-upload/consuntivo-upload.service';
import * as toastr from 'toastr';
import {MonthlyChargesUploadService} from '../../monthly-charges/monthly-charges-upload/service-changes-upload/monthly-charges-upload.service';
import {ProviderModel} from 'src/models/ProviderModel';
import { ConsuntivoForecastUploadService } from 'src/app/monthly-actual/consuntivo-forecast-upload/service-consuntivo-forecast-upload/consuntivo-forecast-upload.service';
import { BillingUploadService } from 'src/app/billing/billing-upload-tab/service-billing-upload/billing-upload.service';
import {ResultBodyModel} from '../../../models/ResultBodyModel';
import { BandwidthUploadService } from 'src/app/bandwidth/bandwidth-upload-tab/service-bandwidth-upload/bandwidth-upload.service';
import { LoaderService } from 'src/app/general-services/service-loader/loader.service';

@Component({
  selector: 'app-material-file-upload',
  templateUrl: './material-file-upload.component.html',
  styleUrls: ['./material-file-upload.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [
        animate(300, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class MaterialFileUploadComponent implements OnInit {

  /** Link text */
  @Input() text = 'Upload file';
  /** Name used in form which will be sent in HTTP request. */
  @Input() param = 'file';
  /** File extension that accepted, same as 'accept' of <input type="file" />.
   By the default, it's set to 'image/*'. */
  @Input() accept = '.xlsx,.csv';
  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() complete = new EventEmitter<string>();
  @Output() uploading = new EventEmitter<boolean>();

  files: Array<FileUploadModel> = [];
  consuntivoSubscribe: Subscription;
  timerId:any;

  @Input() numAnnoMese?: any;
  @Input() provider?: ProviderModel;
  @Input() status?: string;
  @Input() uploadType?: string;

  constructor(private _http: HttpClient,
              private consuntivoUpload: ConsuntivoUploadService,
              private serviceChangesUpload: MonthlyChargesUploadService,
              private forecastUploadService: ConsuntivoForecastUploadService,
              private billingUploadService: BillingUploadService,
              private loaderService: LoaderService,
              private bandwidthUploadService: BandwidthUploadService) {
  }

  ngOnInit(): void {
    
  }

  startTimer() {
    this.timerId = setInterval(() => {
      this.consuntivoUpload.getStatusImport().subscribe(
        (result: any) => {
          console.log("status attuale: ", result)
          if(result == 'success'){
            toastr.success('File uploaded with success', 'Success', {
              timeOut:0,
              extendedTimeOut: 0,
            closeButton:true
            });
            this.loaderService.display(false);
            this.stopTimer();
          }
          else if(result == 'error'){
            toastr.warning('File not uploaded, contact the Administrator', 'Fatal Error', {
              timeOut:0,
              extendedTimeOut: 0,
            closeButton:true
            });
            this.stopTimer();
          }
        });
    }, 40000); // 15 secondi in millisecondi
  }

stopTimer(){
  clearInterval(this.timerId);
}

  onClick() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({ data: file, state: 'in',
          inProgress: false, progress: 0, canRetry: false, canCancel: true });
      }
      this.uploadFiles();
    };
    fileUpload.click();
  }

  cancelFile(file: FileUploadModel) {
    this.consuntivoSubscribe.unsubscribe();
    this.removeFileFromArray(file);
  }

  retryFile(file: FileUploadModel) {
    this.uploadFile(file);
    file.canRetry = false;
  }

  private uploadFile(file: FileUploadModel) {
    const fd = new FormData();
    const fileName = file.data.name;
    fd.append(this.param, file.data);

    if (this.uploadType === 'consuntivo') {
      this.uploading.emit(true);
      this.consuntivoSubscribe =
        this.consuntivoUpload.uploadConsumptive(fd, this.numAnnoMese, this.provider.cod, this.status)
        .subscribe(
          (event: any) => {
            if (event) {
              toastr.success('File:"' + fileName + '" uploaded with success', 'Success',{
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              } );
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
            }
            if (!event) {
              toastr.warning('File:"' + fileName + '" uploaded, check in Waste', 'Warning', {
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
            }
          }, error => {
            if(error.error === "504.0 GatewayTimeout" || error.error.includes("500 - The request timed out")){
              console.log("Inizio timer")
              this.startTimer();
            }else{
              toastr.warning('File:"' + fileName + '" not uploaded, contact the Administrator', 'Fatal Error', {
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
            file.inProgress = false;
            file.canRetry = true;
            return of(`${file.data.name} upload failed.`);
            }

          }
        );
    } else if (this.uploadType === 'forecast') {
      this.uploading.emit(true);
      this.status = 'final';
      this.consuntivoSubscribe =
        this.forecastUploadService.uploadConsumptiveForecast(fd, this.numAnnoMese, this.provider.cod, this.status)
        .subscribe(
          (event: ResultBodyModel) => {
            if (event.success) {
              toastr.success('File:"' + fileName + '" uploaded with success', 'Success');
              this.removeFileFromArray(file);
              this.complete.emit('' + event.success);
            }
            if (!event.success) {
              toastr.warning('File:"' + fileName + '" ' + event.errorDescription, 'Warning', { timeOut: 10000 });
              this.removeFileFromArray(file);
              this.complete.emit('' + event.success);
            }
          }, error => {
            toastr.warning('File:"' + fileName + '" not uploaded, contact the Administrator', 'Fatal Error', { timeOut: 15000 });
            file.inProgress = false;
            file.canRetry = true;
            return of(`${file.data.name} upload failed.`);
          }
        );
    } else if (this.uploadType === 'billing') {
      console.log(this.uploadType)
      this.uploading.emit(true);
      this.status = 'final';
      this.consuntivoSubscribe =
        this.billingUploadService.uploadBilling(fd, this.numAnnoMese, this.provider.cod, this.status)
        .subscribe(
          (event: ResultBodyModel) => {
            if (event.success) {
              toastr.success('File:"' + fileName + '" uploaded with success', 'Success',{
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
              this.removeFileFromArray(file);
              this.complete.emit('' + event.success);
            }
            if (!event.success) {
              toastr.warning('File: "' + fileName + '" ' + event.errorDescription, 'Warning',{
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
              this.removeFileFromArray(file);
              this.complete.emit('' + event.success);
            }
          }, error => {
            toastr.warning('File:"' + fileName + '" not uploaded, contact the Administrator', 'Fatal Error',{
              timeOut:0,
              extendedTimeOut: 0,
            closeButton:true
            });
            file.inProgress = false;
            file.canRetry = true;
            return of(`${file.data.name} upload failed.`);
          }
        );
        
    } 
    else if (this.uploadType === 'bandwidth') {
      console.log(this.uploadType)
      this.uploading.emit(true);
      this.consuntivoSubscribe =
        this.bandwidthUploadService.uploadBandwidth(fd, this.numAnnoMese, this.provider.cod, this.status)
        .subscribe(
          (event: ResultBodyModel) => {
            if (event.success) {
              toastr.success('File:"' + fileName + '" uploaded with success', 'Success',{
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
              this.removeFileFromArray(file);
              this.complete.emit('' + event.success);
            }
            if (!event.success) {
              toastr.warning('File: "' + fileName + '" ' + event.errorDescription, 'Warning',{
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
              this.removeFileFromArray(file);
              this.complete.emit('' + event.success);
            }
          }, error => {
            toastr.warning('File:"' + fileName + '" not uploaded, contact the Administrator', 'Fatal Error',{
              timeOut:0,
              extendedTimeOut: 0,
            closeButton:true
            });
            file.inProgress = false;
            file.canRetry = true;
            return of(`${file.data.name} upload failed.`);
          }
        );
        
    }
    else if (this.uploadType === 'monthly-charges') {
      this.uploading.emit(true);
      this.consuntivoSubscribe =
        this.serviceChangesUpload.uploadMonthlyCharges(fd, this.numAnnoMese, this.provider.cod, this.status)
        .subscribe(
          (event: any) => {
            if (event) {
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
              toastr.success('File:"' + fileName + '" uploaded with success', 'Success',{
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
            }
            if (!event) {
              this.removeFileFromArray(file);
              this.complete.emit(event.body);
              toastr.warning('File:"' + fileName + '" uploaded, check in Waste', 'Warning', {
                timeOut:0,
                extendedTimeOut: 0,
              closeButton:true
              });
            }
          }, error => {
            toastr.warning('File:"' + fileName + '" not uploaded, contact the Administrator', 'Fatal Error', {
              timeOut:0,
              extendedTimeOut: 0,
            closeButton:true
            });
            file.inProgress = false;
            file.canRetry = true;
            return of(`${file.data.name} upload failed.`);
          }
        );
    }

  }

  private uploadFiles() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.value = '';

    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }

  private removeFileFromArray(file: FileUploadModel) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

}

export class FileUploadModel {
  data: File;
  state: string;
  inProgress: boolean;
  progress: number;
  canRetry: boolean;
  canCancel: boolean;
  sub?: Subscription;
}
